var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loggedIn)?_c('div',{attrs:{"id":"notFound"}},[_c('h1',[_vm._v("Not Found")]),_vm._m(0),_c('br'),_c('router-link',{staticClass:"btn",attrs:{"to":"/"}},[_vm._v("Go to Homepage")])],1):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" The resource you're looking for doesn't exist,"),_c('br'),_vm._v(" confirm your URL is correct and try again ")])
}]

export { render, staticRenderFns }